/**
 * Gold pill announcing an active "pay X, get Y" promo (e.g. 2x1) on an event.
 * `compact` renders the short version for small cards.
 */
export default function EventPromoBadge({ promo, compact = false, className = '' }) {
  if (!promo || !promo.label) return null;
  const tag = promo.pay_x === 1 && promo.free_units === 1
    ? 'Llevá un amigo gratis'
    : `${promo.free_units} de regalo`;
  return (
    <span
      className={`inline-flex items-center gap-1 font-black uppercase tracking-wide bg-gradient-to-r from-[#D4AF37] to-[#F2D272] text-black rounded-full shadow-[0_0_20px_rgba(212,175,55,0.55)] ${
        compact ? 'px-1.5 py-0.5 text-[8px] sm:px-2 sm:py-1 sm:text-[9px]' : 'px-2.5 py-1 text-[10px] sm:text-[11px]'
      } ${className}`}
      title={`Pagás ${promo.pay_x}, llevás ${promo.get_y}`}
      data-testid="event-promo-badge"
    >
      🎁 {promo.label}{!compact && <span className="hidden sm:inline">&nbsp;· {tag}</span>}
    </span>
  );
}
